import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44d87cbd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "top__wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "소식", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode(" 더조인의"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("최신 소식을 만나보세요. ")
], -1))
const _hoisted_5 = { class: "top__wrap__nav" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-right" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "active" }, "회사소개", -1))
const _hoisted_8 = {
  class: "tab",
  id: "tab"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "wrap" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "img-wrap"
}
const _hoisted_13 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Layout = _resolveComponent("Layout")!

  return (_openBlock(), _createBlock(_component_Layout, { onScroll: $setup.onScroll }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("p", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
            }, " 홈 "),
            _hoisted_6,
            _hoisted_7
          ])
        ])
      ]),
      _createElementVNode("ul", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tabArr, (tab) => {
          return (_openBlock(), _createElementBlock("li", {
            key: tab.i,
            class: _normalizeClass(
					$setup.activeTab == tab ? 'active' : null
				),
            onClick: ($event: any) => ($setup.activeTab = tab)
          }, _toDisplayString(tab), 11, _hoisted_9))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.newsJson, (item, index) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["news", item.image ? null : 'small']),
            key: item.i,
            onClick: ($event: any) => (_ctx.$utils.newsClick(item.newsSn))
          }, [
            (item.image)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("img", {
                    src: $setup.resolveUrl(item.image),
                    alt: "뉴스이미지",
                    loading: "lazy"
                  }, null, 8, _hoisted_13)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("h4", null, _toDisplayString(item.title), 1),
              _createElementVNode("b", null, _toDisplayString(item.boardClf), 1),
              _createElementVNode("span", null, _toDisplayString(item.date), 1)
            ])
          ], 10, _hoisted_11)), [
            [_vShow, 
					($setup.activeTab == '전체 소식' &&
						index < $setup.showOffset) ||
					(item.boardClf == $setup.activeTab &&
						index < $setup.showOffset)
				]
          ])
        }), 128))
      ]),
      ($setup.showOffset < $setup.newsJson.length)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "more",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.showMore && $setup.showMore(...args)))
          }, " 소식 더보기 "))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onScroll"]))
}